import { createMuiTheme } from '@material-ui/core/styles';
import colors from '../styles/_colors.module.scss';

export default createMuiTheme({
    palette: {
        primary: { main: colors.secondGreen },
        secondary: { main: colors.primaryGreen }
    },
    typography: { useNextVariants: true },
    overrides: {
        MuiFormLabel: { root: { color: 'black' } },
        MuiInput: {
            root: { color: 'black' },
            underline: {
                '&:after': { borderBottom: `2px solid ${colors.primaryGreen}` },
                '&$focused:after': { borderBottom: `2px solid ${colors.secondGreen}` },
                '&:hover:not($disabled):not($focused):not($error):before': { borderBottom: `2px solid ${colors.primaryGreen}` }
            }
        },
        MuiButton: {
            contained: {
                backgroundColor: colors.primaryGreen,
                borderRadius: 30,
                border: 0,
                color: '#ffffff',
                padding: '7px 20px',
                boxShadow: `0px 5px 5px -3px rgba(0, 0, 0, 0.2),
                            0px 2px 5px 1px rgba(0, 0, 0, 0.14),
                            0px 3px 14px 2px rgba(0, 0, 0, 0.12)`,
                '&:hover': {
                    backgroundColor: colors.selectedGreen,
                    transition: `background-color 250ms
                                cubic-bezier(0.4, 0, 0.2, 1) 0ms,
                                box-shadow 250ms
                                cubic-bezier(0.4, 0, 0.2, 1) 0ms,
                                border 250ms
                                cubic-bezier(0.4, 0, 0.2, 1) 0ms;`
                },
                minWidth: '140px',
                width: 'auto',
                height: 36
            }
        },
        MuiAppBar: {
            root: {
                height: '65px',
                paddingLeft: '15px',
                paddingRight: '15px',
                paddingTop: '20px'
            },
            colorPrimary: {
                backgroundColor: 'transparent',
                boxShadow: 'none'
            }
        },
        MuiToolbar: {
            root: {
                paddingLeft: '5px !important',
                paddingRight: '0px !important'
            }
        },
        MuiDrawer: {
            root: { height: '100%' },
            paper: {
                backgroundColor: 'transparent',
                display: 'flex',
                justifyContent: 'space-between',
                overflow: 'hidden',
                position: 'relative',
                top: 'auto',
                width: '65px'
            },
            paperAnchorDockedLeft: { borderRight: 'none' }
        },
        MuiButtonBase: {
            root: {
                height: '40px',
                width: '40px'
            }
        },
        MuiTypography: { root: { fontSize: '16px !important' } },
        MuiExpansionPanel: {
            root: {
                border: 0,
                minHeight: 75,
                boxShadow: 'none'
            }
        },
        MuiExpansionPanelSummary: {
            root: {
                minHeight: 75,
                padding: 0,
                width: '100%',
                transition: 'all 0.25s cubic-bezier(0.5, 0.85, 0.45, 1)',
                border: 'none',
                '&:hover': { transform: 'scale(1.002, 1.002)' }
            },
            content: {
                alignItems: 'center',
                display: 'flex',
                '& > :last-child': { paddingRight: 0 }
            }
        },
        MuiExpansionPanelDetails: {
            root: {
                paddingLeft: 0,
                paddingRight: 0
            }
        },
        MuiTooltip: {
            tooltip: {
                fontSize: 12,
                padding: 10,
                fontWeight: 100
            }
        },
        MuiDialogTitle: {
            root: {
                '& h6': {
                    fontSize: '1.2rem !important',
                    fontWeight: 700,
                    lineHeight: 1.6
                }
            }
        },
        MuiDialogContent: {
            root: { '& p': { lineHeight: 1.6 } }
        },
        MuiChip: {
            root: { boxShadow: '0 1px 2px 0 #3c40434d, 0 1px 3px 1px #3c404326' },
            avatar: {
                fontSize: '0.9rem',
                marginRight: 5
            },
            avatarColorPrimary: { backgroundColor: colors.primaryGreen },
            deleteIcon: {
                fontSize: 20,
                marginLeft: 5
            }
        }
    }
});
